import React, { useState, useEffect } from "react";
import { Tabs, Tab, Container } from "react-bootstrap";
import Badge from "react-bootstrap/Badge";
import axiosInstance from "../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Checkout from "./CheckoutApproved";
import CheckoutOrders from "./Check-Out-Orders";

export default function ManageCheckout() {
  const [analytic, setAnalytic] = useState(null);
  const [count, orderCounts] = useState(null);
  const [tabKey, setTabKey] = useState('home'); // Track the active tab
  const storedPermissions = localStorage.getItem("userPermissions");
  const permissions = storedPermissions ? JSON.parse(storedPermissions) : [];

  const hasPermission = (permission) => {
    return Array.isArray(permissions) && permissions.includes(permission);
  };

  const fetchAnalytic = async () => {
    try {
      const analyticResponse = await axiosInstance.get("/user/fetch-analytic");
      const orderCountResponse = await axiosInstance.get("/user/check_out/get_all_order_approved_by_chain_supply");

      setAnalytic(analyticResponse.data.data.data);
      orderCounts(orderCountResponse.data.data.order_count);
    } catch (error) {
      console.error("Error fetching analytic:", error);
    }
  };

  // Use effect for fetching data when the tab changes
  useEffect(() => {
    fetchAnalytic();
  }, [tabKey]); // Fetch data again when tabKey changes

  return (
    <div className="manage-permissions">
      {/* Start page title */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0" style={{ color: "#c4281c" }}>
              Checkout Management
            </h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/app/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" style={{ color: "#c4281c" }}>
                  Checkout Management
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* End page title */}

      <div className="card">
        <div className="card-header">
          <Tabs
            activeKey={tabKey}
            onSelect={(k) => setTabKey(k)} // Set the active tab
            id="manage-tabs"
            className="d-flex justify-content-around mb-3 nav-tabs"
          >
            <Tab
              eventKey="home"
              title={
                <>
                  Check-Out&nbsp;{" "}
                  <Badge text="dark" className="badg">
                    {count && count}
                  </Badge>
                </>
              }
            >
              <Container className="mt-4 pt-4 pb-3">
                <Checkout key={tabKey} /> 
              </Container>
            </Tab>
            <Tab
              eventKey="profile"
              title={
                <>
                  View Checked Out Orders&nbsp;{" "}
                  <Badge text="dark" className="badg">
                    {analytic && analytic.check_out_approved_orders}
                  </Badge>
                </>
              }
            >
              <Container className="mt-4 pt-4 pb-3">
                <CheckoutOrders key={tabKey} /> {/* Re-render when tabKey changes */}
              </Container>
            </Tab>
          </Tabs>
        </div>
        <div className="card-body"></div>
      </div>
    </div>
  );
}
